import { render, staticRenderFns } from "./repayment-record-query.vue?vue&type=template&id=5e8456e8"
import script from "./repayment-record-query.vue?vue&type=script&lang=ts"
export * from "./repayment-record-query.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports